(function(){
    'use strict';
    angular.module('Directives').directive('bbaMapOfficeLocation', bbaMapOfficeLocation);
    bbaMapOfficeLocation.$inject = ['MapLegendsConst', 'GoogleMapService', 'toastr'];

    function bbaMapOfficeLocation(MapLegendsConst, GoogleMapService, toastr){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/office-location/bbaMapOfficeLocation.html',
            scope: {
                location: '='
            },
            link: bbaMapOfficeLocationLink
        }

        function bbaMapOfficeLocationLink(scope) {
            let googleMapInstance;
            let warehouseMarkers = [];

            scope.init = init;

            function init(){
                initMap();
                scope.$watch('location.location', (location) => {
                    addOfficeLocationMarker(location);
                }, true);
            }

            function initMap(){
                googleMapInstance = new google.maps.Map(document.getElementById('map-office-location'), {
                    disableDefaultUI: true
                });
            }

            function addOfficeLocationMarker(location){
                if(location) {
                    if (!location.latitude || !location.longitude) {
                        const centerOfWorld = { lat: 40.1848, lng: 34.1999 };
                        googleMapInstance.panTo(centerOfWorld);
                        googleMapInstance.setZoom(0);
                        createOfficeWarehouseLocationMarker(centerOfWorld);
                        return; 
                    }

                    const lat = location.latitude; 
                    const lng = location.longitude;
                    const position = {lat: lat, lng: lng};
                    
                    googleMapInstance.panTo(position);
                    googleMapInstance.setZoom(14);
                    createOfficeWarehouseLocationMarker(position);
                }
            }

            function createOfficeWarehouseLocationMarker(position) {
                clearPreviousOfficeMarker();

                let image = MapLegendsConst.getIcons('locations').url;
                let officeLocationMarker = new google.maps.Marker({
                    position: position,
                    map: googleMapInstance,
                    icon: image,
                    draggable: true
                });

                google.maps.event.addListener(officeLocationMarker, 'dragend', onChangeMarker);
                
                warehouseMarkers.push(officeLocationMarker);
            }

            function onChangeMarker(event) {
                const latLng = event.latLng;
                const center = {lat: latLng.lat(), lng: latLng.lng()};
                googleMapInstance.panTo(center);

                const payload = {
                    serviceName: 'admin AU',
                    methodName: 'address',
                    lat: latLng.lat(), 
                    lng: latLng.lng()
                };
                GoogleMapService.latLngToAddress(data => {
                    const addrData = parseAddressData(data.address);
                    scope.location.addressLine1 = addrData.addressLine1; 
                    scope.location.addressLine2 = addrData.addressLine2;
                }, error => {
                    toastr.error(error.message, 'Error');
                }, payload);
            }

            function parseAddressData(address) {
                const addrArray = address.split(','); 
                if (addrArray.length > 2) {
                    return {
                        addressLine1: `${addrArray[0]} ${addrArray[1]} ${addrArray[2]} `,
                        addressLine2: addrArray.slice(3).map(addr => addr.trim()).join(' ')
                    };
                }

                return {
                    addressLine1: address,
                    addressLine2: ''
                };
            }

            function clearPreviousOfficeMarker(){
                warehouseMarkers.forEach( marker => {
                    marker.setMap(null);
                });
                warehouseMarkers = [];
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/office-location/bbaMapOfficeLocation.js